import type { Recipe } from '../../build-config';
import { isSelect } from '../helpers/elevations';
import { planLayer, roofLayer, sidingLayer } from '../helpers/layers';

export const selectRecipe = (state?: Recipe['state']): Recipe => ({
  layers: [planLayer, roofLayer, sidingLayer],
  where: isSelect,
  state
});
